import { useInformationList } from "@/api/services/main/information";
import { NotificationList } from "@/components/commons/notification/NotificationList";
import { InfiniteScroll } from "@/components/elements/InfiniteScroll";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { Tab } from "@/components/elements/Tab";
import { NOTIFICATION_TAB, NOTIFICATION_TAB_LABEL, TNotificationTab } from "@/features/dashboard/constants/notificationTab";
import { divider } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { Box } from "@mui/material";
import { FC, useState } from "react";

export type TNotificationProps = {
  isSingleLine?: boolean;
  isHideContent?: boolean;
};

export const Notification: FC<TNotificationProps> = ({ isSingleLine = false, isHideContent = false }) => {
  const [tab, setTab] = useState<TNotificationTab>(NOTIFICATION_TAB.ALL);
  const {
    dataFormatter: informationListData,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = useInformationList({
    types: tab === NOTIFICATION_TAB.ALL ? ["system", "tenant"] : tab,
  });

  return (
    <Tab
      value={tab}
      onChange={(_, tab) => setTab(tab.toString())}
      options={Object.values(NOTIFICATION_TAB).map((tab) => ({ label: NOTIFICATION_TAB_LABEL[tab], value: tab }))}
    >
      <Box border={`1px solid ${divider.middle}`} sx={{ borderBottomLeftRadius: rounded.sm, borderBottomRightRadius: rounded.sm }}>
        {!informationListData || isLoading ? (
          <LoadingArea height={100} />
        ) : (
          <InfiniteScroll loadMore={fetchNextPage} hasMore={hasNextPage}>
            <NotificationList
              data={informationListData.map((notification) => ({
                id: notification.id,
                description: notification.content,
                time: notification.createdAt,
                title: notification.title,
                type: notification.type,
                filePath: notification.filePath,
              }))}
              isSingleLine={isSingleLine}
              isHideContent={isHideContent}
            />
          </InfiniteScroll>
        )}
      </Box>
    </Tab>
  );
};
